exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.description-container[data-v-e754b1a0]{padding:0;margin-top:20px}}\n", ""]);

// exports
